import { createAsyncThunk } from "@reduxjs/toolkit";
import localhost from "apis/localhost";

const OWNER_URL = (ownerType, ownerId) =>
  `/api/activity/owner/${ownerType}/${ownerId}`;

const ENTITY_URL = (entityType, entityId) =>
  `/api/activity/entity/${entityType}/${entityId}`;

const buildParams = (offset, pageSize) => ({ offset, pageSize });

const targetKey = (type, id) => `${type}:${id}`;

export const fetchOwnerActivity = createAsyncThunk(
  "activityLog/fetchOwnerActivity",
  async ({ ownerType, ownerId, offset = 0, pageSize = 50 }) => {
    const { data } = await localhost.get(OWNER_URL(ownerType, ownerId), {
      params: buildParams(offset, pageSize),
    });
    return { key: targetKey(ownerType, ownerId), response: data };
  }
);

export const fetchEntityActivity = createAsyncThunk(
  "activityLog/fetchEntityActivity",
  async ({ entityType, entityId, ownerType, ownerId, offset = 0, pageSize = 50 }) => {
    const { data } = await localhost.get(ENTITY_URL(entityType, entityId), {
      params: { ...buildParams(offset, pageSize), ownerType, ownerId },
    });
    return { key: targetKey(entityType, entityId), response: data };
  }
);
